import { render, staticRenderFns } from "./PublicSpaceSectionBlock.vue?vue&type=template&id=a18af936&"
import script from "./PublicSpaceSectionBlock.vue?vue&type=script&lang=js&"
export * from "./PublicSpaceSectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./PublicSpaceSectionBlock.vue?vue&type=style&index=0&id=a18af936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports